enum PauseType {
    Resume = "pause/RESUME",
    Pause = "pause/PAUSE",
}

export default PauseType;
